import React, {PureComponent} from 'react';
import { connect } from 'dva';
import { Modal, Button, Carousel, Checkbox, DatePicker, Form, Input, Radio, Select, Row, Col} from 'antd';
import { injectStripe, CardElement, CardNumberElement, CardExpiryElement} from 'react-stripe-elements';
import Dimio, {FormComponent, Numeric, ButtonPlus, ButtonMinus, DimioModal} from 'dimio';
import QuoteFlight from './QuoteFlight';
//import ParticipantForm from './ParticipantForm';
import {showError} from '../../../lib/Common';
import TermsConditions from './TermsCondition';
import Policy from './Policy';
import moment from 'moment';
import business from 'moment-business';

import config from '../config/config';

const {Option} = Select;
const {MonthPicker} = DatePicker;
const {fields, api, stripeStyle} = config.purchase;
const TYPE_AYERSROCK = 'ayersrock';

const ADATE = business.addWeekDays(moment(), 20);

// disableしたい期間はここを変更する
const DISABLED_DATE = [
  { start: moment('2024-12-23'), end: moment('2025-01-12') }
];

export class Numeric2 extends PureComponent {
  constructor(props) {
    super(props);
//    console.info(props);

    this.state = {
      value: this.props.value?this.props.value:0
    };

    this.plus = this.plus.bind(this);
    this.minus = this.minus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  plus(){
    let value = this.state.value;
//    let value = this.props.value;
    value = value+1;
    this.setState({value: value});
    this.props.onChange(value, this.props.id);
  }
  minus(){
    let min = (this.props.min)?this.props.min:0;
    let value = this.state.value;
//    let value = this.props.value;
    value = (value > min)?value-1:min;
    this.setState({value: value});
    this.props.onChange(value, this.props.id);
  }
  onChange(e){
    e.preventDefault();
    const value = e.target.value;
    this.setState({value: value});
  }
  onBlur(e) {
    e.preventDefault();
//    console.info(e.target.value);
    if (e.target.value.length > 0) {
      this.props.onChange(parseInt(e.target.value), this.props.id);
    }
  }
  render() {
    return(
      <div className={this.props.className?this.props.className:null}>
        <Input.Group>
          <Row gutter={16}>
            <Col span={6}>
              <Button onClick={this.minus} icon='minus' className='dimio-numeric-button btn btn-primary btn-block' />
            </Col>
            {/*
            <Col span={8}>
              <label className="dimio-numeric-label">
                {this.props.icon &&
                <span className="dimio-numeric-icon">{this.props.icon}</span>
                }
                <span className="title">
            {this.props.label}
            </span>
              </label>
            </Col>
            */}
            <Col span={12}>
              <Input
                className="dimio-numeric-input text-center"
                value={this.state.value}
                onBlur={this.onBlur}
                onChange={this.onChange}
              />
            </Col>
            <Col span={6}>
              <Button onClick={this.plus} icon='plus' className='dimio-numeric-button btn btn-primary btn-block' />
            </Col>
          </Row>
        </Input.Group>
      </div>
    )
  }
}

const Step = (props) => (
  <section>
    <span className="desc text-danger">STEP.{props.step}</span>
    <h2 className="purchase-form__title">{props.title}</h2>
    {/* <h2 className="purchase-form__Modal">連絡先を入力</h2> */}
    <div className="py-3 px-3 mb-5 bg-light rounded border">
      {props.children}
    </div>
  </section>
);


class PurchaseFormBase extends FormComponent {
  constructor(props) {
    super(props);

    this.state = {
      readTC: false,
      cardError: null,

      optionAccommodation: null,
      optionFlight: null,
      optionPickup: null,

      noa: 1,
      noc: 0
    };

    this.handleSubmit = this.handleSubmit.bind(this);

    this.onSelectFlight = this.onSelectFlight.bind(this);
    this.onSelectAccommodation = this.onSelectAccommodation.bind(this);
    this.onSelectPickup = this.onSelectPickup.bind(this);

    this.onChange = this.onChange.bind(this);
    this.onChangeNoa  = this.onChangeNoa.bind(this);
    this.onChangeNoc  = this.onChangeNoc.bind(this);
  }

  componentDidMount() {
    const {core:{defaultValues}, form} = this.props;

    const map = ['email', 'phone', 'first_name', 'last_name', 'gender', 'enquiry'];
    let initialValues = {};

    if(form) {
      for (let key of map) {
        if (defaultValues[key]) {
          initialValues[key] = defaultValues[key];
        }
      }

      if(defaultValues.date){
//        initialValues[key] = moment(defaultValues.date);
      }
//      defaultValues.noa = 1;
//      console.info(initialValues);
      form.setFieldsValue(initialValues);
    }
  }


  onChange(stripe){
//    console.info('change',stripe);
    /*
    if(stripe.brand === 'jcb'){
      this.setState({cardError: ErrorMessages.jcb});
    }else{
      this.setState({cardError: null});
    }

    if(stripe.complete){
      this.setState({readTC:true, cardError: null, initState:false});
    }else if(stripe.error){
      this.setState({cardError: stripe.error.message});
    }
    */
  }

  handleChange(o) {
    console.info(o);
    const {stripe} = this.props;
  }

  onSelectFlight(e){
    e.preventDefault();
    this.setState({optionFlight: e.target.value});
  }

  onSelectAccommodation(e){
    e.preventDefault();
    this.setState({optionAccommodation: e.target.value});
  }

  onSelectPickup(e){
    e.preventDefault();
    console.info(e.target.value);
    this.setState({optionPickup: e.target.value});
  }

  onChangeNoa(noa){
    this.setState({noa: noa});
  }
  onChangeNoc(noc){
    console.info(noc);
    this.setState({noc: noc});
  }

  handleSubmit(e) {
    e.preventDefault();

    const {form, stripe, core:{test, defaultValues}} = this.props;
    const { noa, noc } = this.state;

    try {
      form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.showLoading();

          stripe.createToken({name: values.name})
            .then(({token, error}) => {
              console.log('Received Stripe token:', token);

              if(error){
                console.info(error);
                this.hideLoading();
                this.setState({cardError: error.message});
              }else{
                //          if(token) {
                const _data = values;
                _data.token = token;
                if(_data.date) {
                  _data.date = _data.date.format('YYYY-MM-DD');
                }
                _data.test = test;
                _data.amount = (+noa * +defaultValues.amount) + (+noc * +defaultValues.amount_child);
                _data.product_id       = defaultValues.tour_id;
                _data.product_sub_id   = defaultValues.plan_id;
                _data.payment_category = defaultValues.payment_category;
                _data.fee_adult = defaultValues.amount;
                _data.fee_child = defaultValues.amount_child;
                _data.charge = false;

/*
                if(noc > 0){
                  for(let i=0; i < noc; i++){
                    if(_data.child_dob[i] !== undefined){
                      _data.child_dob[i] = _data.child_dob[i].format('YYYY-MM-DD');
                    }
                  }
                }
*/
                console.info(_data);

                const opt = {
                  checkSuccess:true,
                  format: 'json'
//                  debug: true
                };

                Dimio.save(api.payment, _data, opt).then(res => {
                  console.info('done', res);

                  if(test == 1) {
                    alert('Test is done');
                    this.hideLoading();
                  }else {
                    window.location.href = defaultValues.thankyou ? defaultValues.thankyou : '/pay/thankyou';
                  }
                }).catch(err => {
                  const msg = showError(err);
                  /*
                  scroller.scrollTo('step03', {
                    duration: 500,
                    smooth: true,
                  });
                  */

                  this.setState({cardError:msg});
//                  message.error(_error);
                  this.hideLoading();
                })
              }
            });
        }
      });
    }catch(e){
      console.error(e);
    }
  }

  render() {
    const Field = this.Field;
    const Submit = this.Submit;

    const { core:{defaultValues} } = this.props;
    const { noa, noc } = this.state;

//    console.info(!this.state.readTC);
    const adata = JSON.parse(defaultValues.avaiable_date);
    const times = defaultValues.times?JSON.parse(defaultValues.times):false;


//    console.info(adata);
    /*
    const AvailableCards = () => (
      <div className="row">
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/visa.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/mastercard.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/themes/travel/dev/images/logo/amex.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="//tora-tora.net/img/travel/discover.png" />
        </div>
      </div>
    );
*/

//    console.info(defaultValues);

    const extraContact = [];
    if(noa && noa > 1) {
      for (let i = 1; i < noa; i++) {
        extraContact.push(
          <div className='border rounded bg-white p-3 mb-3'>
          <div key={`adult_${i}`}>
            <p className='font-weight-bold border-bottom pb-1'>参加者 {i + 1}</p>
            <div className="purchase-form__gender">
            <Field {...fields.gender} name={`adult_gender[${i - 1}]`}>
              <Radio.Group>
                {fields.gender.items.map(item => (
                  <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                ))}
              </Radio.Group>
            </Field>
            </div>
            <Row gutter={16}>
              <Col xs={12} sm={12}>
                <Field className='mb-1' {...fields.first_name} name={`adult_first_name[${i - 1}]`}>
                  <Input/>
                </Field>
              </Col>
              <Col xs={12} sm={12}>
                <Field className='mb-1' {...fields.last_name} name={`adult_last_name[${i - 1}]`}>
                  <Input/>
                </Field>
              </Col>
            </Row>
            <div className='font-size-xs'><span className="text-danger">*</span> パスポートと同じローマ字でご入力ください。</div>
          </div>
          </div>
        )
      }
    }

    if(noc && noc > 0) {
      for(let i=0; i<noc; i++) {
        extraContact.push(
          <div className='border rounded bg-white p-3 mb-3'>
          <div key={`child_${i}`}>
            <p className='font-weight-bold border-bottom pb-1'><span  className='text-info lead'><i className="fas fa-child"></i></span> 子供 {i + 1}</p>
            <div className="purchase-form__gender">
            <Field {...fields.gender} name={`child_gender[${i}]`}>
              <Radio.Group>
                {fields.gender.items.map(item => (
                  <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                ))}
              </Radio.Group>
            </Field>
            </div>
            <Row gutter={16}>
              <Col xs={12} sm={12}>
                <Field className='mb-1' {...fields.last_name} name={`child_last_name[${i}]`}>
                  <Input/>
                </Field>
              </Col>
              <Col xs={12} sm={12}>
                <Field className='mb-1' {...fields.first_name} name={`child_first_name[${i}]`}>
                  <Input/>
                </Field>
              </Col>
            </Row>
            <div className='font-size-xs'><span className="text-danger">*</span> パスポートと同じローマ字でご入力ください。</div>
            {/* <Row gutter={16}>
              <Col xs={8}> */}
                <Field {...fields.dob} name={`child_dob[${i}]`}>
                  {/* <DatePicker /> */}
                  <Input placeholder='2017-12-30'/>
                </Field>
            {/* </Col>
              <Col xs={8}>
                <Field {...fields.dob} name={`child_dob_year[${i}]`}>
                  <DatePicker mode='year'/>
                </Field>
              </Col>
              <Col xs={8}>
                <Field {...fields.dob} name={`child_dob_year[${i}]`}>
                  <DatePicker mode='year'/>
                </Field>
              </Col>
            </Row> */}
          </div>
          </div>
        )
      }
    }


    return (
      <Form onSubmit={this.handleSubmit}>

        <div className="purchase-form__Modal mb-4">
          <h2 className="purchase-form__Modal_title">お申込み前に注意事項をご確認ください</h2>
          <DimioModal
            buttonLabel='注意事項を読む'
          >
            <TermsConditions/>
          </DimioModal>
        </div>

        <Step step='01' title='参加希望日と人数を入力'>
          {times && times.length > 0 &&
          <Field {...fields.time}>
            <Select>
              <Option key={false} value='-1'>選択してください</Option>
              {times.map((item,idx) => (
                <Option key={idx} value={item}>{item}</Option>
              ))}
            </Select>
          </Field>
          }

          <Field {...fields.date}>
            {defaultValues.staff == 1 ?
              <DatePicker />
              :
              <DatePicker
                className="purchase-form-DatePicker"
                disabledDate={current => {
                  let d = current && (current < ADATE || DISABLED_DATE.some(date => current.isBetween(date.start, date.end, null, '[]')) || current.isSame(moment('2024-12-23'), 'day') || current.isSame(moment('2025-01-12'), 'day'));
                  if (d == false) {
                    const available = adata[current.day()];
                    d = !available;
                  }
                  return d;
                }}
              />
            }
          </Field>
          <Row className="ant-customize--numeric purchase-form__numeric">
            <Col xs={24}>
              <div className="font-size-sm mb-1 font-weight-bold">大人 : <span className="text-success font-weight-bold">AU${defaultValues.amount}~</span></div>
              <Field {...fields.noa} options={{initialValue: 1}}>
                <Numeric2
                  label='大人'
                  onChange={this.onChangeNoa}
                />
              </Field>
            </Col>
            {defaultValues.show_child === "1" &&
            <Col xs={24}>
              <div className="font-size-sm mb-1 font-weight-bold">子供(2 - 12歳) : <span className="text-success font-weight-bold">AU${defaultValues.amount_child}~</span></div>
              <Field {...fields.noc}>
                <Numeric2
                  label='子供'
                  onChange={this.onChangeNoc}/>
              </Field>
            </Col>
            }
          </Row>
        </Step>


        {defaultValues.purchase_type == TYPE_AYERSROCK &&
        <div>
          <h3 className="mt-4 font-weight-bold h5"><span className="badge badge-danger">重要</span> フライトと宿泊先について</h3>
          <div className="py-3 px-3 mb-5 bg-light rounded border">
            <div>
              <div className="ant-customize--radio-group--equally">
                <Field {...fields.flight}>
                  <Radio.Group onChange={this.onSelectFlight}>
                    {fields.flight.items.map(item => (
                      <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                    ))}
                  </Radio.Group>
                </Field>
              </div>

              {this.state.optionFlight === 'yes' &&
              <div className='border rounded bg-white p-3 mb-3'>
                <Field {...fields.flight_info}>
                  <Input />
                </Field>
              </div>
              }

              {this.state.optionFlight === 'quote' &&
              <QuoteFlight {...this.props}/>
              }
            </div>

            {defaultValues.is_camp === "1" ?null:
              <div>
                <Field {...fields.accommodation}>
                  <div className="ant-customize--radio-group--equally">
                    <Radio.Group onChange={this.onSelectAccommodation}>
                      {fields.accommodation.items.map(item => (
                        <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                      ))}
                    </Radio.Group>
                  </div>
                </Field>

                {this.state.optionAccommodation == 'yes' &&
                <div className='border rounded bg-white p-3 mb-3'>
                  <Field {...fields.accommodation_info}>
                    <Select>
                      {fields.accommodation_info.items.map(item => (
                        <Option key={item.key} value={item.label}>{item.label}</Option>
                      ))}
                    </Select>
                  </Field>
                </div>
                }

                {this.state.optionAccommodation == 'quote' &&
                <div className='border rounded bg-white p-3 mb-3'>
                  <Field {...fields.accommodation_quote}>
                    <Select>
                      {fields.accommodation_quote.items.map(item => (
                        <Option key={item.key} value={item.label}>{item.label}</Option>
                      ))}
                    </Select>
                  </Field>
                </div>
                }
              </div>
            }
          </div>
        </div>
        }

        <Step step='02' title='連絡先を入力'>
          <Field {...fields.email}  className='mb-0'>
            <Input className='mb-1' type="email"/>
          </Field>
          <div className='mb-2 font-size-xs'><span className="text-danger">*</span> docomo.ne.jpなどのキャリアメールは海外からのメールを受信することが出来ませんのでご利用できません。gmail, yahoo, hotmailなどをご記入ください。</div>
          <Field {...fields.phone}>
            <Input  type="tel"/>
          </Field>
        </Step>
        {defaultValues.is_pickup == 1 &&
          <div className="py-3 px-3 mb-5 bg-light rounded border">
            <div>
              <Field {...fields.pickup}>
                <div className="ant-customize--radio-group--equally">
                  <Radio.Group onChange={this.onSelectPickup}>
                    {fields.pickup.items.map(item => (
                      <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              </Field>

              {this.state.optionPickup == 'hotel' &&
              <div className='border rounded bg-white p-3 test'>
                <Field {...fields.pickup_hotel}>
                  <Input />
                </Field>
              </div>
              }
              {this.state.optionPickup == 'local' &&
              <div className='border rounded bg-white p-3 test'>
                <p className="font-weight-bold mb-1"><span className="text-danger">*</span> 個人宅にご滞在、または現地在住の方</p>
                <p>シェアハウスや、バッパーなどに滞在されている場合、市内ホテルへの集合となります。ツアー予約が完了後に集合場所ホテルをお知らせします。</p>
              </div>
              }
            </div>
          </div>
        }
        <Step step='03' title='お客様情報を入力'>
          <div className="purchase-form__gender">
            <p className="font-weight-bold border-bottom pb-1">代表者 <small>(参加者 1)</small></p>
          </div>
          <div className="purchase-form__gender">
            <Field {...fields.gender}>
              <Radio.Group>
                {fields.gender.items.map(item => (
                  <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
                ))}
              </Radio.Group>
            </Field>
          </div>
          <Row gutter={16}>
            <Col xs={12} sm={12}>
              <Field className='mb-1' {...fields.first_name}>
                <Input />
              </Field>
            </Col>
            <Col xs={12} sm={12}>
              <Field className='mb-1' {...fields.last_name}>
                <Input />
              </Field>
            </Col>
          </Row>
          <div className='font-size-xs mb-3'><span className="text-danger">*</span> パスポートと同じ表記でご入力ください。</div>
          {extraContact}
        </Step>

        <Step step='04' title='お支払い情報を入力'>
          <div className='purchase-items mb-3'>
            <div className='bg-white border rounded p-3'>
            <Row className='purchase-item'>
              <Col xs={12}>
                大人 x {noa}名
              </Col>
              <Col xs={12}>
                <div className="float-right">
                  AU${+noa * +defaultValues.amount}
                </div>
              </Col>
            </Row>
            {noc > 0 &&
            <Row className='purchase-item'>
              <Col xs={12}>
                子供 x {noc}名
              </Col>
              <Col xs={12}>
                <div className="float-right">
                  AU${+noc * +defaultValues.amount_child}
                </div>
              </Col>
            </Row>
            }
            <hr />
            <Row type="flex" align="middle" className='purchase-total'>
              <Col xs={12}>
                <div className="font-weight-bold">
                  合計
                </div>
              </Col>
              <Col xs={12}>
                <div className="float-right font-weight-bold text-success">
                  AU<span className="lead font-weight-bold">${(+noa * +defaultValues.amount) + (+noc * +defaultValues.amount_child)}</span>
                </div>
              </Col>
            </Row>
            </div>


          </div>

          <Form.Item
            className={this.state.cardError?"payment-field error":"payment-field"}
            label={fields.payment.label}
          >
            <CardElement
              elementRef={e => this.element = e}
              //          elementRef={this.setRef}
              //              value={{postalCode: '11111'}}
              //              hidePostalCode={true}
              style={stripeStyle}
              //                onBlur={this.handleBlur}
              //              onReady={this.handleReady}
              onChange={this.onChange}
            />
            <div className="mb-0 mt-2" style={{lineHeight: "1.5"}}><span className="text-danger">*</span> JCBカードはご利用できません。</div>
            <div className="mb-0 mt-2" style={{lineHeight: "1.5"}}><span className="text-danger">*</span> CVC（Card Verification Code = カード確認コード）とはクレジットカードの裏面、署名欄に記載されている最後の3桁（AMEXの場合、カード前面4桁）暗証番号です。</div>
          </Form.Item>
          {this.state.cardError &&
          <div className="card-error" role="alert">{this.state.cardError}</div>
          }
        </Step>

        <Step step='05' title='その他の必要事項、ご要望等を入力'>
          <div className="font-size-sm mb-2">お体の不自由な方、その他ツアー参加時の注意事項がありましたらご記入ください（アレルギー・ベジタリアンなど）。<br />なお、ツアー当日の連絡先携帯番号が入力された番号と異なる場合はこちらにご記入ください。</div>
          <Field {...fields.enquiry}>
            <Input.TextArea rows={3} />
          </Field>

          <div className="purchase-form__Modal mb-4">
            <DimioModal
              buttonLabel='利用規約を読む'
            >
              <Policy/>
            </DimioModal>
          </div>
          <div className="font-size-sm font-weight-bold text-danger mb-3">* 必ず利用規約を一読ください。<br />ご同意いただくとお申込みが可能になります。</div>
          <div className="text-center purchase-form__check">
            <Checkbox onChange={(e) => this.setState({readTC: e.target.checked})}>利用規約に同意して申し込む</Checkbox>
          </div>
        </Step>

        <div className="purchase-form__submit">
          <Submit
            disabled={!this.state.readTC}>
            この内容で申し込む
          </Submit>
        </div>
      </Form>
    );
  }
}

/*
const InitForm = {
mapPropsToFields(props) {
const {purchase} = props;

const map = ['email', 'first_name','last_name', 'gender','phone', 'optionAccommodation', 'accommodation'];

const initValues = {};
for(let key of map){
  if(purchase[key]){
    initValues[key] = Form.createFormField({value: purchase[key]})
  }
}
console.info('init',initValues);
    return initValues;
  }
};
*/

//const PurchaseForm = Form.create(InitForm)(PurchaseFormBase);
const PurchaseForm = Form.create()(PurchaseFormBase);

export default connect(({ core, purchase }) => ({
  core, purchase,
}))(injectStripe(PurchaseForm));



// WEBPACK FOOTER //
// ./src/pages/purchase/components/PurchaseForm.js